const defaults = require('./defaults');

module.exports = {
  ...defaults,
  hot: false,
  mode: 'production',
  sourceMap: 'source-map',
  cacheControl: 'max-age=600',
  auth: {
    responseType: 'token id_token',
    scope: 'openid',
    domain: 'preprod.auth.localsearch.cloud',
    audience: 'https://services.lsapis.com.au',
    clientID: 'laXaCzyRbTndb82v0lBjVhJUVpQkWxtc',
    redirectUri: 'https://preprod.ls-www.localsearch.cloud/login-loader',
    returnTo: 'https://preprod.ls-www.localsearch.cloud',
  },
  urlRoot: 'https://preprod.ls-www.localsearch.cloud',
  serviceApiRoot: 'https://preprod.services.lsapis.com.au',
  serviceGraphqlRoot: 'https://preprod.services.lsapis.com.au/graphql',
  addABusinessRoot:
    'https://preprod.ls-business-profile.localsearch.cloud/create-profile',
  imageResizeRoot: 'https://d7dgpygyd9llm.cloudfront.net',
  token: {
    ...defaults.token,
    cookie: { domain: '.localsearch.cloud' },
  },
  bpm: {
    baseUrl: 'https://preprod.ls-business-profile.localsearch.cloud',
  },
  v2UrlRoot: `https://preprod.ls-www.localsearch.cloud`,
  elastic: {
    nodes: [
      'http://10.41.7.29:9200',
      'http://10.41.8.157:9200',
      'http://10.41.10.196:9200',
    ],
    maxSize: 10,
    cacheControl: 'no-cache',
    indexes: {
      cms: 'cms',
    },
  },
  deploy: {
    vpcSubnetIds: [
      'subnet-028e162d20a10922c',
      'subnet-0a49feb8543497bd0',
      'subnet-05402128d59b5b46c',
    ],
    vpcSecurityGroupIds: [
      'sg-008199e3a16a9d23c',
      'sg-0c700589bff236328',
      'sg-0de546142084a41ca',
    ],
  },
};
